/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMp4 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m10.723 15.29 1.572-3.307h1.125V17h-1.063v-3.251l-1.325 2.768h-.662l-1.325-2.723V17H8.003v-5.017h1.125zm5.468-3.307c.617 0 1.082.143 1.395.428.317.285.475.709.476 1.27 0 .372-.072.685-.214.938a1.327 1.327 0 0 1-.628.566c-.276.13-.62.194-1.029.194h-.724V17h-1.07v-5.017zm-.724 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.234-.635-.152-.124-.412-.186-.78-.186h-.504zm6.169.663h.69v.896h-.69V17h-1.022v-.939h-2.311v-.828l2.374-3.18h.959zm-2.22 0h1.226V13.48z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMp4 as FileMp4 };
